import ReportingDashboard from './ReportingDashboard';

export default ReportingDashboard;
